import React from "react";
import {Link} from "react-router-dom";
import { useTranslation } from "react-i18next";
import crossIcon from '../assets/img/icon/x.svg';

export function Signin() {
    const { t } = useTranslation();
    return (
        <div className="flex-main">
            <Link className="button outline light" to="/sign-in"><span className="txt">{t('ui.sign_in')}</span></Link>
        </div>
    );
}

export function Settings() {
    const { t } = useTranslation();
    return (
        <div className="topbar-links">
            <button className="close flat-button" data-remove=".topbar-links">
              <img src={crossIcon} alt="" />
            </button>
            <Link className="button outline light" to="/sign-in"><span className="txt">{t('ui.sign_in')}</span></Link>
            <Link className="button text" to="/sign-in"><span className="txt">{t('ui.settings')}</span></Link>
        </div>
    );
}
